import { jsx as m } from "react/jsx-runtime";
import * as c from "react";
import { c as k } from "./index-SYE1cn5_.js";
const y = c.forwardRef(function({
  children: e,
  color: o = "primary",
  href: r,
  target: a,
  underline: n = "hover",
  unstyled: i,
  className: s,
  ...t
}, l) {
  return /* @__PURE__ */ m(
    "a",
    {
      ref: l,
      href: r,
      className: k("link", `link--${o}`, s, {
        "link--underline-hover": n === "hover",
        "link--underline-none": n === "none",
        "link--unstyled": i
      }),
      target: a,
      style: { textDecoration: n === "always" ? "underline" : "none" },
      ...t,
      children: e
    }
  );
});
export {
  y as L
};
